import {
  Card,
  CardHeader,
  makeStyles,
  tokens,
  Text,
  Badge,
  ProgressBar,
} from '@fluentui/react-components';
import { ArrowTrendingRegular } from '@fluentui/react-icons';
import type { DiagnosticPillarKey } from '../types';
import { getScoreColor, PILLAR_LABELS } from '../utils/scoring';

interface PillarCardProps {
  pillarKey: DiagnosticPillarKey;
  score: number;
  accentColor: string;
  trend?: number;
}

const useStyles = makeStyles({
  card: {
    minWidth: '220px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  scoreRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  scoreValue: {
    fontSize: '28px',
    fontWeight: 700,
  },
  trendIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '13px',
    fontWeight: 600,
  },
});

export function PillarCard({ pillarKey, score, accentColor, trend }: PillarCardProps) {
  const styles = useStyles();
  const badgeColor = getScoreColor(score);
  const label = PILLAR_LABELS[pillarKey];

  const trendColor = trend && trend > 0 ? '#0E7A0D' : trend && trend < 0 ? '#D13438' : undefined;

  return (
    <Card className={styles.card}>
      <CardHeader
        header={<Text weight="semibold">{label}</Text>}
      />
      <div style={{ padding: `0 ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL}` }}>
        <div className={styles.content}>
          <div className={styles.scoreRow}>
            <span className={styles.scoreValue} style={{ color: accentColor }}>
              {score}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {trend !== undefined && trend !== 0 && (
                <span className={styles.trendIndicator} style={{ color: trendColor }}>
                  <ArrowTrendingRegular style={{ transform: trend < 0 ? 'scaleY(-1)' : undefined }} />
                  {trend > 0 ? '+' : ''}{trend}
                </span>
              )}
              <Badge appearance="filled" color={badgeColor}>
                / 100
              </Badge>
            </div>
          </div>
          <ProgressBar
            value={score / 100}
            thickness="large"
            color={badgeColor === 'danger' ? 'error' : badgeColor}
          />
        </div>
      </div>
    </Card>
  );
}
